import { GetDetailResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _DeepLinkService {
  public createLink(bookId: number) {
    return HttpService.get<
      GetDetailResponse<{ shortLink: string; previewLink: string }>
    >(`/user/api/v2/deeplinks/book/${bookId}`);
  }
}

const DeepLinkService = new _DeepLinkService();

export default DeepLinkService;
